import request from '@/utils/request'
//get
export function getModuleAuthParam(param) {
    return request({
        url: `/module_auth/${param}`,
        method: 'GET'
    })
}
export function getModule() {
    return request({
        url: `/module/`,
        method: 'GET'
    })
}

export function trail(data) {
    return request({
        url: `/module_auth/trail/`,
        method: 'POST',
        data
    })
}
//试用延期
export function trialDelay(id) {
    return request({
        url: `/module_auth/${id}/delay`,
        method: 'GET',
    })
}

export function buyPrice(data) {
    return request({
        url: `/module_auth/buy_price/`,
        method: 'POST',
        data
    })
}

export function buy(data) {
    return request({
        url: `/module_auth/buy/`,
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/module.js